import axios from 'axios';

let dynamicToken = null;
// Stagione selezionata in UI: inviata al BE come header X-Season-Id (null = stagione corrente)
let activeSeasonId = null;
export const setActiveSeasonId = (seasonId) => {
  activeSeasonId = seasonId;
};
// Funzione per aggiornare il token dinamico
export const setDynamicToken = (token) => {
  dynamicToken = token;
};

// Crea un'istanza Axios con il baseURL preso dall'ambiente
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Esempio di interceptor per gestire le richieste e le risposte
axiosClient.interceptors.request.use(
  (config) => {
    const token = dynamicToken || localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = token; // già nel formato "Basic ..."
    }
    if (activeSeasonId != null) {
      config.headers['X-Season-Id'] = String(activeSeasonId);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Puoi aggiungere logica personalizzata per ogni errore qui
    return Promise.reject(error);
  }
);

export default axiosClient;
